const Auth = new Object();
Auth.loggedIn = false;
Auth.EmpId = null;
Auth.roles = {recruitment: {rec: false, ops: false, emp: false, admin: false, it: false}};

export default Auth;




/** WEBPACK FOOTER **
 ** ./src/redux/actions/Authentication/auth.class.js
 **/